/**
 * @returns v4 UUID (https://developer.mozilla.org/en-US/docs/Web/API/Crypto/randomUUID)
 */
export const generateUUID = () => {
  const uuid = self?.crypto?.randomUUID();
  return uuid ?? `${new Date().valueOf()}`;
};

export const formatFullyQualifiedUrl = (url: string) => {
  if (url.startsWith(location.protocol)) {
    return url;
  }

  return `${location.protocol}${url}`;
};

export const getFullyQualifiedUrl = (url: string): URL => {
  if (!url) return null;
  return new URL(formatFullyQualifiedUrl(url));
};

// eslint-disable-next-line no-template-curly-in-string
export function formatMoney(cents: number | string, format = "${{amount}}") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision?, thousands?, decimal?) {
    const p = precision;

    precision = precision || 2;
    thousands = thousands || ",";
    decimal = decimal || ".";

    if (isNaN(number) || number === null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";

    if (p === 0) {
      return dollarsAmount;
    } else {
      return dollarsAmount + centsAmount;
    }
  }

  switch (format.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_trailing_zeroes":
      value = formatWithDelimiters(cents, 2).replace(".00", "");
      break;
  }

  return format.replace(placeholderRegex, value);
}

export const getShopifySectionRenderUrl = (
  sectionId: string,
  productHandle?: string
) => {
  const path = productHandle
    ? `/products/${productHandle}`
    : window.location.pathname;
  const url = new URL(`${window.location.origin}${path}`);
  url.searchParams.append("sections", sectionId);

  return url;
};

export const parseSectionDom = (sectionString: string, sectionId: string) => {
  const parser = new DOMParser();
  const { body } = parser.parseFromString(sectionString, "text/html");
  const sectionHTML = body.querySelector<HTMLElement>(
    `#shopify-section-${sectionId}`
  );
  return sectionHTML;
};

export const getHeaderHeights = () => {
  const navBar = document.querySelector<HTMLElement>(".site-header");
  const navBarHeight = navBar ? navBar.clientHeight : 0;
  const stickyBar = document.querySelector<HTMLElement>(
    ".section-announcement-bar"
  );
  const stickyBarHeight = stickyBar ? stickyBar.clientHeight : 0;
  const heightsTotal = navBarHeight + stickyBarHeight;
  return heightsTotal;
};
